export default {
    callable: (element: HTMLElement) => {
        createObserver();

        let observer: IntersectionObserver;
        function createObserver() {
            let options = {
                root: null,
                rootMargin: '0px',
                threshold: [0.5],
            };

            observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(element);
        }

        let handle: number;

        function handleIntersect(entries: IntersectionObserverEntry[]) {
            entries.forEach((entry) => {
                if (entry.intersectionRatio >= 0.5) {
                    handle = window.setTimeout(handleInscreen, 1000);
                } else {
                    if (handle) {
                        clearTimeout(handle);
                    }
                }
            });
        }

        function handleInscreen() {
            if (observer) {
                observer.unobserve(element);
                observer.disconnect();
            }

            const lazyImgEles = element.querySelectorAll(
                'img[data-viewed-element-src]'
            );
            [].forEach.call(lazyImgEles, (ele: HTMLImageElement) => {
                ele.addEventListener('load', () => {
                    if (ele.parentNode) {
                        ele.parentNode.removeChild(ele);
                    }
                });
                const viewSrc =
                    ele.getAttribute('data-viewed-element-src') || '';
                ele.src = viewSrc;
                ele.removeAttribute('data-viewed-element-src');
                updateClicked(element, viewSrc);
            });
        }
    },
};

function updateClicked(element: HTMLElement, viewScr: string) {
    const anchor = element.closest('a');
    if (anchor) {
        const fullUrl = new URL(viewScr);
        const baseUrl = fullUrl.origin;

        const params = fullUrl.searchParams;
        const index = params.get('distribution.index');
        const total = params.get('distribution.total');

        if (index !== null && total !== null) {
            const anchorSrc = anchor.href;
            const fullAnchorUrl = new URL(anchorSrc);
            const rawReportUrl = fullAnchorUrl.searchParams.get('report');
            if (rawReportUrl) {
                const parts = rawReportUrl.split(',');
                if (parts.length > 0) {
                    const [reportUrl, ...restUrls] = parts;
                    const fullReportUrl = new URL(reportUrl, baseUrl);
                    fullReportUrl.searchParams.set('distribution.index', index);
                    fullReportUrl.searchParams.set('distribution.total', total);
                    const withoutBase = fullReportUrl.href.replace(
                        baseUrl + '/',
                        ''
                    );

                    const updatedRawReportUrl = [withoutBase, ...restUrls].join(
                        ','
                    );

                    fullAnchorUrl.searchParams.set(
                        'report',
                        updatedRawReportUrl
                    );
                    anchor.setAttribute('href', fullAnchorUrl.href);
                }
            }
        }
    }
}
